import React from 'react';
import { View } from 'react-native';
import BreakLine from '../General/BreakLine';
import Title from '../Text/Title';
import { Customers_write_reason } from '../../../utils/DictionaryManagementUtils';
import RadioPanel from './RadioPanel';
import SwitcherPanel from './SwitcherPanel';

//= ========================================================================

const RadioPanelMenu = ({
  radioPanelValueChanged,
  expandedComponentValue,
  headline,
  headlineLeftOption,
  headlineRightOption,
  onPressLeftOption,
  onPressRightOption,
  hideTopBreakLine,
  language,
}) => (
  <View>
    {!hideTopBreakLine && <BreakLine marginTop={30} />}
    <Title isBold>{headline}</Title>
    <RadioPanel
      value={radioPanelValueChanged}
      headlineLeftOption={headlineLeftOption}
      headlineRightOption={headlineRightOption}
      onPressLeftOption={() => onPressLeftOption(true)}
      onPressRightOption={() => onPressLeftOption(false)}
      language={language}
    />
    {radioPanelValueChanged && (
      <SwitcherPanel
        text={Customers_write_reason}
        value={expandedComponentValue}
        onValueChanged={(value) => {
          onPressRightOption(value);
        }}
        marginBottom={30}
        internalFlag
      />
    )}
  </View>
);
export default RadioPanelMenu;
